import { render, staticRenderFns } from "./AppUserSideMenu.vue?vue&type=template&id=6d6b9ad4"
import script from "./AppUserSideMenu.vue?vue&type=script&lang=js"
export * from "./AppUserSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports